import { LE } from "@/constants/enumsNew";
import { type Report, type ReportRequest } from "@/views/report/report";
import { getLookupMetadata } from "@modernary/mui/components/lookup";

export default {
  addAuthRequestFields,
  getInitialData,
  skinnyResponseAdapter,
  requestAdapter,
  fromFormkit,
  toFormkit,
  responseAdapter,
};

function addAuthRequestFields(entity: Report) {
  entity._authRequestFields = ["id", "statusMurn"] as (keyof Report)[];
  return entity;
}
function getInitialData(params?: any) {
  const result = { permitId: params?.permitId ? parseInt(params.permitId) : null } as Report;
  return addAuthRequestFields(result);
}

/** Be sure to await this when using it. Commonly used for lists and child lists */
async function skinnyResponseAdapter(response: { data: Report }) {
  //TODO:TS
  response.data.isRecurring =
    response.data.frequencyMurn !== LE.ReportFrequencies.OneTime &&
    response.data.frequencyMurn !== LE.ReportFrequencies.AsNeeded;
  addAuthRequestFields(response.data);
  return response.data;
}

/** Be sure to await this when using it. */
async function responseAdapter(response: { data: Report }) {
  await skinnyResponseAdapter(response);

  return response.data;
}

async function requestAdapter(data: ReportRequest) {
  if (data.typeMurn) {
    const metadata = await getLookupMetadata(data.typeMurn);
    data.manualPeriodDates = Boolean(metadata?.hasManualPeriodDates);
  }
  return data;
}

// Convert server data for use in the page's form (which may have groupings, etc different from the server data)
function toFormkit(data: any) {}

// Convert formkit data to prep it for sending to the server (which is probably flatter than the fk data)
function fromFormkit(data: any) {}
